<template>
  <div class="page-body">
    <div
      class="nr"
      :class="{
        'has-adj-footer': isSave && pList.length,
      }"
    >
      <div class="fix-table-box">
        <div class="date">
          <a-select
            v-model:value="sortBy"
            :dropdownMatchSelectWidth="120"
            @change="sortByChange"
            style="font-size: 12px"
          >
            <a-select-option
              :key="item.text"
              :value="item.value"
              v-for="item in sortItem"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </div>
        <ul :style="'transform:translateX(-' + xScroll + 'px)'">
          <li v-for="x in oArr" :key="x">#{{ x }}</li>
        </ul>
      </div>
      <div v-if="pList.length" class="has-fix-s-c">
        <div class="fix-s-box">
          <ul :style="'transform:translateY(-' + yScroll + 'px)'">
            <li v-for="items in pList" :key="items.worderDate">
              {{ dateWrap(items.worderDate) }}
            </li>
          </ul>
        </div>
        <div class="table-box" ref="tableBoxRef">
          <div class="s-row -px" v-for="(items, pIndex) in pList" :key="pIndex">
            <div
              class="box-card shipment-box-card"
              v-for="item in sort(items.workOrders, 'planPickupDate')"
              :key="item.id"
              :class="{
                grey: !item.shipStatus,
                blue: item.shipStatus == 1,
                green: item.shipStatus == 2,
                optionShow: props.pressStatus === 'option',
                sriShow: props.pressStatus === 'sri',
                fwdShow: props.pressStatus === 'fwd',
              }"
            >
              <div class="in">
                <h3 @dblclick="openDetailModal(item)">
                  <span>{{ item.customerPoNo }}_{{ item.groupNo }}</span>
                  <span class="t-r">
                    {{ item.routeId }}
                    <i
                      class="iconfont"
                      :class="{
                        'icon-lunchuan2': item.shipMode === 1,
                        'icon-feiji2': item.shipMode === 0,
                        'icon-icon3': item.shipMode === 2,
                        'icon-huochezhanxiao': item.shipMode === 3,
                      }"
                    ></i>
                  </span>
                </h3>
                <div class="list status-bar-list">
                  <div class="item">
                    <span class="btn">J</span>
                    <span
                      class="status"
                      :class="{
                        blue: item.jobStatus * 1 == 0,
                        'half blue': item.jobStatus * 1 == 1,
                        'whole blue': item.jobStatus * 1 == 2,
                      }"
                    >
                      <b>{{ item.jobId }}</b>
                    </span>
                  </div>
                  <div class="item" @click="modifyState(item, 1)">
                    <span class="btn">O</span>
                    <span
                      class="status"
                      :class="{
                        blue: item.optionStatus * 1 == 0,
                        'half blue': item.optionStatus * 1 == 1,
                        'whole blue': item.optionStatus * 1 == 2,
                      }"
                    >
                      <b>{{ item.optionNumber }}</b>
                    </span>
                  </div>
                  <div class="item" @click="modifyState(item, 2)">
                    <span class="btn">S</span>
                    <span
                      class="status"
                      :class="{
                        grey: item.sriStatus == 0,
                        'half blue': item.sriStatus == 1,
                        'whole blue': item.sriStatus == 2,
                      }"
                    ></span>
                  </div>
                  <div class="item" @click="modifyState(item, 3)">
                    <span class="btn">F</span>
                    <span
                      class="status"
                      :class="{
                        grey: item.fwdStatus == 0,
                        'half blue': item.fwdStatus == 1,
                        'whole blue': item.fwdStatus == 2,
                      }"
                    ></span>
                  </div>
                  <div
                    class="item"
                    :class="{
                      hide: item.jobId && item.jobId.toLowerCase() === 'option',
                    }"
                  >
                    <span class="l-text">
                      {{
                        item.eEnd ? dayjs(item.eEnd).format('MM/DD HH:mm') : ''
                      }}
                    </span>
                    <span class="c-text"></span>
                    <span
                      class="r-text t-strong"
                      :class="{ danger: item.gap < 0, green: item.gap >= 0 }"
                    >
                      {{ millisecondToHour(item.gap) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-empty style="margin-top: 100px" v-else />
    </div>
    <!-- 底部 -->
    <div
      class="adj-footer"
      :class="{
        show: isSave && pList.length,
      }"
    >
      <a-button type="primary" :loading="confirmLoading" @click="confirmSave()">
        Save
      </a-button>
      <a-button @click="$emit('needRefresh')">Cancel</a-button>
    </div>
    <!--leveling 底部-->

    <!-- 详情 -->
    <DetailModal
      :detailItem="currentDetail"
      :isOpen="detailModalVis"
      @onModalClose="detailModalVis = false"
    ></DetailModal>
  </div>
</template>
<script setup>
  import dayjs from 'dayjs'
  import {
    defineProps,
    ref,
    watch,
    watchEffect,
    defineEmits,
    computed,
  } from 'vue'
  import DetailModal from './detail-modal.vue'
  import { deepClone } from '@/utils'
  import request from '@/utils/request'
  import { message } from 'ant-design-vue'
  const emits = defineEmits()
  const props = defineProps({
    dataList: Array,
    sortName: String,
    pressStatus: String,
  })
  const sortItem = [
    { text: 'PlanPick', value: 'planPickupDate' },
    { text: 'RSDS', value: 'rsdsReqPickupDate' },
    { text: 'ActualPick', value: 'actualPickupDate' },
  ]
  const millisecondToHour = (text) => {
    return Math.round((text / 3600000) * 100) / 100
  }
  const sort = (arr, name) => {
    return arr.sort((a, b) => {
      return a[name] - b[name]
    })
  }
  const sortBy = ref(props.sortName)
  // 控制滚动条
  const tableBoxRef = ref(null)
  const xScroll = ref(0)
  const yScroll = ref(0)
  watch(tableBoxRef, (v) => {
    if (!v) return
    tableBoxRef.value.removeEventListener('scroll', tbScrollFn)
    tableBoxRef.value.addEventListener('scroll', tbScrollFn, false)
  })
  const tbScrollFn = (e) => {
    const { scrollLeft, scrollTop } = e.target
    xScroll.value = scrollLeft
    yScroll.value = scrollTop
  }
  //日期处理
  const dateWrap = (v) => {
    if (!v) return ''
    var s = v.split('/')
    return s[1] + '/' + s[2]
  }
  // 详情
  const detailModalVis = ref(false)
  const currentDetail = ref({})
  const openDetailModal = (item) => {
    currentDetail.value = item
    detailModalVis.value = true
  }

  const workOrderInit = (items, attr) => {
    var dateStrArr = [],
      getData = [],
      sortDate = []

    items.forEach((item) => {
      if (item[attr] == null) {
        return
      }
      var d = dayjs(item[attr]).format('YYYY/MM/DD')
      dateStrArr.push(d)
    })
    if (dateStrArr.length != 0) {
      sortDate = Array.from(new Set(dateStrArr)).sort()

      for (var i = 0; i < sortDate.length; i++) {
        getData.push({
          worderDate: sortDate[i],
          workOrders: [],
          amountOfWorders: 0,
        })
        items.forEach((item) => {
          var str = dayjs(item[attr]).format('YYYY/MM/DD')
          if (str == sortDate[i]) {
            item.reqEnd2 = dayjs(item.reqEnd)
            getData[i].workOrders.push(item)
            getData[i].amountOfWorders++
          }
        })
      }
      getData.forEach((item) => {
        //按属性排序
        item.workOrders.sort(compare(attr))
      })
      return getData
    } else {
      return []
    }
  }
  const workOrderXlist = (data) => {
    //获取不同日期中最大的订单长度
    var orderSizeArr = [],
      oArr = []
    if (!(data && data.length)) return
    data.forEach((item) => {
      orderSizeArr.push(item.amountOfWorders)
    })
    var orderMax = Math.max.apply(Math, orderSizeArr)
    for (var i = 1; i < orderMax + 1; i++) {
      oArr.push(i)
    }
    return oArr
  }
  const compare = (property) => {
    return function (a, b) {
      var value1 = a[property]
      var value2 = b[property]
      if (a.batchUploadId === b.batchUploadId) {
        return value1 - value2
      }
      return a.batchUploadId - b.batchUploadId
    }
  }

  const pList = ref([])
  const oArr = ref([])
  const isSave = computed(() => !!changeData.value.length)
  const changeData = ref([])
  watchEffect(() => {
    if (props.dataList.length) {
      pList.value = workOrderInit(deepClone(props.dataList), sortBy.value)
      oArr.value = workOrderXlist(pList.value)
      changeData.value = []
    } else {
      pList.value = []
      oArr.value = []
      changeData.value = []
    }
    if (props.pressStatus) {
      changeData.value = []
    }
  })
  const sortByChange = (v) => {
    emits('sortDateChange', v)
  }
  const modifyState = (item, type) => {
    if (type == 1 && props.pressStatus == 'option') {
      if (item.optionStatus * 1 === 1) {
        item.optionStatus = 2
      } else if (item.optionStatus * 1 === 2) {
        item.optionStatus = 0
      } else {
        item.optionStatus = 1
      }
    } else if (type === 2 && props.pressStatus == 'sri') {
      if (item.sriStatus * 1 === 0) {
        item.sriStatus = 2
      } else {
        item.sriStatus = 0
      }
    } else if (type === 3 && props.pressStatus == 'fwd') {
      if (item.fwdStatus * 1 === 1) {
        item.fwdStatus = 2
      } else if (item.fwdStatus * 1 === 2) {
        item.fwdStatus = 0
      } else {
        item.fwdStatus = 1
      }
    }
    /**
     * 用初始状态值与更改后状态值对比，如果修改过，加入changeData列表中
     */
    const filedMap = { 1: 'optionStatus', 2: 'sriStatus', 3: 'fwdStatus' }
    const f = props.dataList.find((m) => m.id === item.id) // 原始值
    const index = changeData.value.findIndex((m) => m.headerId === item.id)
    if (f[filedMap[type]] * 1 !== item[filedMap[type]] * 1) {
      if (index !== -1) {
        changeData.value[index].status = item[filedMap[type]]
      } else {
        changeData.value.push({
          headerId: item.id,
          status: item[filedMap[type]] * 1,
        })
      }
    } else {
      if (index !== -1) {
        changeData.value.splice(index, 1)
      }
    }
  }
  const confirmLoading = ref(false)
  const confirmSave = () => {
    confirmLoading.value = true
    const map = {
      option: 'changeOptionStatus',
      sri: 'changeSriStatus',
      fwd: 'changeFwdStatus',
    }
    request({
      url: `api/shipment/${map[props.pressStatus]}`,
      method: 'post',
      data: changeData.value,
    })
      .then(() => {
        message.success('State modification success').then(() => {
          emits('needRefresh')
        })
      })
      .finally(() => {
        confirmLoading.value = false
      })
  }
</script>
<style lang="less" scoped>
  @import '../less/scheduling.less';
  @import '../less/index.less';
  .handle {
    position: absolute;
    left: 10px;
    top: 3px;
    cursor: move;
  }
</style>
